import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const quarantineUserTableColumns: ITableColumn[] = [
  {
    labelPath: 'issuesPage.quarantineUserDialog.tableColumns.name',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.Text,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'issuesPage.quarantineUserDialog.tableColumns.email',
    propertyKey: 'email',
    colType: TableColumnTypeEnum.Text,
    width: 50,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'issuesPage.quarantineUserDialog.tableColumns.role',
    propertyKey: 'role',
    colType: TableColumnTypeEnum.Text,
    width: 180,
    widthType: WidthType.Percentage,
    toCapitalize: true,
  },
];
